module.exports = __webpack_public_path__ + "static/media/er.48dd6f73.svg";